import allUrl from "../../api/allUrl";
import { post, get, postRaw, headerGet } from "../../api/service/services";
function asyncData(values) {
  return new Promise(function (resolve, reject) {
    post(
      allUrl.register.sensitiveFilter,
      { string: values },
      {
        "Content-Type": "application/json;charset=UTF-8",
      }
    )
      .then((res) => {
        if (res.success === false && res.code != 200) {
          let strData = res.data || [];
          resolve(strData);
        } else {
          reject([]);
        }
      })
      .catch((res) => {
        reject(null);
      });
  })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return error;
    });
}
export const Sensitive = async (values) => {
  let val = "";
  let flag = false;
  let datas = await asyncData(values);
  if (datas == null) {
    flag = true;
    return {
      flag: flag,
      val: values,
      err: "error",
    };
  }
  if (datas.length > 0) {
    datas.forEach((item) => {
      let regSign = new RegExp(item, "g"); //这里的g表示全局替换
      if (regSign.test(values)) {
        if (flag) {
          val = val.replace(regSign, `<font style="color:red;">${item}</font>`);
        } else {
          val = values.replace(
            regSign,
            `<font style="color:red;">${item}</font>`
          );
        }
        flag = true;
      } else {
        val = val ? val : values;
      }
    });
  } else {
    val = values;
  }

  return {
    flag: flag,
    val: val,
  };
};
